import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AgreementReadModel, RelationshipType } from '@client/api';
import { combineStrings } from '@client/toolkit';

export const useAgreementPartiesNumerationText = (
  agreement: AgreementReadModel | undefined | null,
  type?: RelationshipType,
): string | undefined => {
  const { t } = useTranslation();

  const text = useMemo(() => {
    if (
      agreement == null ||
      agreement.parties == null ||
      !Array.isArray(agreement.parties) ||
      agreement.parties.length <= 0
    ) {
      return;
    }

    let parties = agreement.parties;

    if (type != null) {
      parties = agreement.parties.filter((x) => x.type === type);
    }

    if (parties == null || !Array.isArray(parties) || parties.length <= 0) {
      return;
    }

    const firstItem = parties[0];

    if (firstItem == null) return;

    const name = firstItem.stakeholder?.name ?? '-';

    if (parties.length > 1) return combineStrings(', ', name, t('andMore', { count: parties.length - 1 }));

    return name;
  }, [agreement, type, t]);

  return text;
};
